export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgIi9hc3NldHMvbG9nby5kMGM5ZmJlMy5hMWEwMDE2NS0yYzU1LTRhMmMtODJjZS1kZDVhMTQ0OWY3YjAucG5nIjs="